<template>
    <b-container fluid class="d-flex flex-column w-100 h-100 px-2">
        <b-row v-for="section in form.Sections" v-bind:key="section.Name" class="p-3 m-0">
            <b-col class="p-0 m-0">
				<b-card no-body class="p-3">
                    <b-form-group
						:label="section.Label"
						label-cols="12"
						label-cols-lg="12"
						label-class="font-weight-bold text-dark pt-0 pb-2"
						label-align-sm="left"
						label-size="lg"
						class="m-0" />

                    <b-card no-body class="w-100">
                        <b-card-header header-tag="header" header-bg-variant="secondary" class="text-center text-white font-weight-bold pt-0 pb-0" role="tab">
                            {{ section.Label }}
                        </b-card-header>
						
                        <!-- Tableau des Tariffs -->
                        <b-table v-for="table in section.Fields.filter(x => x.Type === fieldTypeEnum.Table)" :key="table['Name']" :fields="convertHeaders(table['Headers'])" :items="table.Value"
                            striped bordered hover small tbody-tr-class="p-0" class="m-0" @row-hovered="onRowHovered" @row-unhovered="onRowUnhovered">
                            <template #head()="data">
                                <div class="text-center">{{ data.label }}</div>
                            </template>

                            <template #cell(StartDate)="data">
                                <div class="text-center">{{ data.value | formatDate('L') }}</div>
                            </template>

                            <template #cell(EndDate)="data">
                                <div class="text-center">{{ data.value | formatDate('L') }}</div>
                            </template>
                            
                            <template #cell()="data">
                                <div class="text-center" >{{ data.value }}</div>
                            </template>
                        </b-table>

                        <!-- Tooltip pour afficher les différentes puissances -->
                        <b-tooltip v-if="tooltipText" show :target="tooltipText.target" noninteractive>
                            <div v-for="value in tooltipText.values">
                                {{ value }}
                            </div>
                        </b-tooltip>

                    </b-card>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">
import { Component } from "vue-property-decorator";
import Fields from "@/components/commons/Fields.vue";
import FieldTypeEnum from "@/enums/fields/FieldTypeEnum";
import TableHeader from "@/types/fields/TableHeader";
import { BaseObjectForm } from "./BaseObjectForm";

/** Composant de gestion des évènements pour la fiche objet */
@Component({
	components: {
		Fields
	}
})
export default class Tariffs extends BaseObjectForm {
    // Utilisation des Enum dans la partie template
    private fieldTypeEnum = FieldTypeEnum;

    // Objet pour l'affichage du tooltip en survol de la ligne du tableau
    private tooltipText : {values : string[] , target} = null;

    /** 
	 * Convertie un TableHeader en header compatible avec le Bootstrap Vue.js b-Table utilisé dans ce composant
	 * @param headers: Liste de TableHeader à convertir
	 *  */
	private convertHeaders(headers: TableHeader[]) {
		let tab = headers.map(o => {
			return { key: o.Name, label: o.Label, sortable: true, thStyle: {} };
		});

		return tab;
	}

    /**
     * Méthode permettant de générer l'objet afin d'afficher le tooltip sur chaque ligne du tableau
     * @param item Informations de la ligne survolée
     * @param index Index de la ligne
     * @param event Evenement
     */
    private onRowHovered(item, index, event){
        let text : string[] = [];

        if(Object.keys(item).includes("Powers")){
            let powers = item.Powers;
            
            if(Object.keys(powers).length > 0){
                for (let key of Object.keys(powers)) {
                    text.push(key + " : " + powers[key] + " kVA"); 
                }

                this.tooltipText = {
                    values : text,
                    target: event.target
                }
            }
        }
    }

    /** Méthode permettant de reinitialiser l'objet du tooltip */
    private onRowUnhovered(){
        this.tooltipText = null;
    }
}
</script>

<style scoped>
</style>